import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AllegatiDipendenti } from 'src/app/models/allegati-dipendenti';


@Injectable({
  providedIn: 'root',
})
export class AllegatiDipendentiService {
  allegatiUrl = environment.ildatoArticoliDpi + 'api/allegati/dipendenti';
  private http = inject(HttpClient);

  list(): Observable<AllegatiDipendenti[]> {
    return this.http.get<AllegatiDipendenti[]>(this.allegatiUrl);
  }

  listByDipendente(idDipendente: number): Observable<AllegatiDipendenti[]> {
    return this.http.get<AllegatiDipendenti[]>(
      this.allegatiUrl + '/bydipendente/' + idDipendente,
    );
  }

  delete(idAllegato: number): Observable<AllegatiDipendenti> {
    return this.http.delete<AllegatiDipendenti>(
      this.allegatiUrl + '/' + idAllegato,
    );
  }

  allega(
    idDipendente: number,
    nome: string,
    data: FormData,
  ): Observable<number> {
    return this.http.post<number>(
      this.allegatiUrl + '/newallegato/' + idDipendente + '/' + nome,
      data,
    );
  }

  scarica(id: number): Observable<Blob> {
    return this.http.get(this.allegatiUrl + '/getallegato/' + id, {
      responseType: 'blob',
    });
  }

  getImmagine(id: number): Observable<string> {
    return this.http.get(this.allegatiUrl + '/getimmagine/' + id, {
      responseType: 'text',
    });
  }
}
